import React, { Fragment } from 'react';
import { useIntl } from 'react-intl';
import classNames from 'classnames';

import { normalizeDefaultToNull } from '@utils/normalize/normalizeDefaultToNull';
import { normalizeStringToBooleanValue } from '@utils/normalize/normalizeStringToBooleanValue';

const Dropdown = props => {
    const {
        inputData: {
            disabled,
            id,
            inputClass,
            isInputRequired,
            handleAsNumbers,
            name,
            options,
            returnAsBoolean,
            type,
            value,
        },
        label: { labelClass, text } = {},
        labelIcon = {},
        shouldParse = false,
        dropdownContainerClassName,
        inputActions: { handleFieldFocus = () => {} } = {},
    } = props;

    const intlApi = useIntl();

    const selectText = intlApi.formatMessage({ id: 'ssap.input.option.select' });

    const handleValueChange = e => {
        const { value } = e.target;

        const text = (o => (o ? (o.value === 'default' ? null : o.text) : null))(options.find(o => o.value === value));

        let valueForSaving;
        switch (true) {
            case value === 'default':
                valueForSaving = normalizeDefaultToNull(value);
                break;
            case handleAsNumbers:
                valueForSaving = +value;
                break;
            case returnAsBoolean:
                valueForSaving = normalizeStringToBooleanValue(value);
                break;
            default:
                valueForSaving = value;
        }
        props.inputActions.handleFieldChange(valueForSaving, text);
    };

    const adjustedValue = value === undefined || value === null || value === '' ? 'default' : value;
    const getOptionValueParsed = optionValue => (shouldParse && optionValue !== '' ? intlApi.formatMessage({ id: optionValue }) : optionValue);
    const getOptionTextParsed = optionText => (shouldParse ? intlApi.formatMessage({ id: optionText }) : optionText);

    return (
        <Fragment>
            <div className={classNames(`grid-row gi-component gi-${type}`, dropdownContainerClassName)}>
                {(text || labelIcon?.icon || (labelClass && labelClass.length > 0)) && (
                    <label
                        data-testid={`${id}_label`}
                        htmlFor={id}
                        className={`tablet:grid-col-4 m-0 gi-${type}__label ${
                            labelClass && labelClass.join(' ')
                        } iconed-${!!labelIcon.icon} required-${isInputRequired}`}
                    >
                        {text}
                        {labelIcon.icon ? labelIcon.icon : null}
                    </label>
                )}
                <select
                    id={id}
                    name={name}
                    aria-required={isInputRequired}
                    className={`tablet:grid-col-6 gi-${type}__select ${inputClass && inputClass.join(' ')}`}
                    data-testid = { `${id}_select` }
                    disabled={disabled}
                    value={adjustedValue} // Should be refactored (undefined, '0')?
                    onChange={handleValueChange}
                    onBlur={props.inputActions.onFieldBlur}
                    onFocus={handleFieldFocus}
                >
                    {options.map((option, idx) => (
                        <option
                            key={`${option.value}_${idx}`}
                            value={getOptionValueParsed(option.value)}
                            data-testid={`${id}_${option.value}`}
                            data-selected={adjustedValue === option.value ? true : undefined}
                            disabled={option.disabled}
                        >
                            {value === '' && option.value === 'default'
                                ? selectText
                                : getOptionTextParsed(option.text)}
                        </option>
                    ))}
                </select>
            </div>
        </Fragment>
    );
};

export default Dropdown;
